import {captureError} from '../../../utils/log';
import {getSearchValues} from '../../../utils/search';
import {status} from '../../../utils/constant';
import organisationService from '../../../services/organisation/OrganisationService';
import interventionService from '../../../services/intervention/InterventionService';
import userService from '../../../services/user/UserService';
import documentService from '../../../services/document/DocumentService';
import history from '../../../history/history';

export const getClient = clientId => new Promise((resolve, reject) => {
  organisationService.get(clientId)
    .then(client => {
      resolve(client);
    })
    .catch(error => {
      captureError('Error while getting client details', error);
      reject();
    });
});

export const getDocuments = params => new Promise((resolve, reject) => {
  documentService.searchByClient(params.organisation.organisationId, params.clientId)
    .then(response => {
      resolve({
        documents: response,
        totalCount: response.length
      });
    })
    .catch(error => {
      captureError('Error while getting documents', error);
      reject();
    });
});

export const getDossierState = ({organisation}) => new Promise((resolve, reject) => {
  documentService.getDossierStateDetails(organisation.organisationId, organisation.country)
    .then(dossierState => {
      resolve({dossierState});
    })
    .catch(error => {
      captureError('Error while getting dossier state', error);
      reject();
    });
});

export const getInterventions = params => new Promise((resolve, reject) => {
  const {page = 0} = getSearchValues(history.location.search);

  const searchParams = [
    params.clientId,
    params.organisation.organisationId,
    status.ACCEPTED,
    page,
    params.interventionsPageSize
  ];

  interventionService.searchByClientAndSubcontractor(...searchParams)
    .then(response => {
      resolve(response);
    })
    .catch(error => {
      captureError('Error while fetching client\'s interventions', error);
      reject();
    });
});

export const getUsers = params => new Promise((resolve, reject) => {
  const {queryString = '', page = 0} = getSearchValues(history.location.search);

  const searchParams = [
    params.clientId,
    queryString,
    page,
    params.usersPageSize
  ];

  userService.publicSearchByOrganisation(...searchParams)
    .then(response => {
      resolve(response);
    })
    .catch(error => {
      captureError('Error while fetching client\'s users', error);
      reject();
    });
});
